<script>
import { CookieConsent } from "@travelata-libs/ui-shared";

function getCookieDomain() {
  if (typeof window === 'undefined') return '';
  const { hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length === 2) {
    return `.${hostname}`;
  }
  return `.${parts.slice(-2).join('.')}`;
}

export default {
  name: "CookieConsentPopup",
  components: { CookieConsent },
  props: {
    cookieName: {
      type: String,
      default: "cookie_consent_accepted",
    },
    cookieValue: {
      type: String,
      default: "true",
    },
    cookiesUrl: {
      type: String,
      default: "https://travelata.ru/cookies-agreement",
    },
    recommendationTechnologyUrl: {
      type: String,
      default: "https://travelata.ru/recommendation-technologies-agreement",
    },
    privacyPolicyUrl: {
      type: String,
      default: 'https://travelata.ru/privacy.html',
    },
    image: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    domain() {
      return getCookieDomain();
    }
  }
};
</script>

<template>
  <CookieConsent v-bind="$props" :domain="domain"/>
</template>

<style scoped lang="scss">
::v-deep .tl-cookie-consent__link {
  color: #059bce;
}

::v-deep .tl-cookie-consent__link:hover {
  color: #04769c;
}

.tl-cookie-consent {
  @media (max-width: 768px) {
    bottom: 84px;
  }
}
</style>